module.exports = __webpack_public_path__ + "static/media/dinosnores_nhm.75edc44f.jpg";